import Chartist from 'chartist';
import addComma from 'utils/add-comma';
import { SPLIT_DATE } from '../components/analytics/models/period';

var regex = /{{([0-9a-z]+)}}/g;
var defaultOptions = {
  tooltipClass: 'ct-tooltip',
  template: '{{y}}',
  hover: 'point',
  labelOffset: {
    x: 0,
    y: 0
  }
};

var fullPoints = [];

Chartist.plugins = Chartist.plugins || {};

function lrChartistTooltipFactory(options) {
  options = Chartist.extend({}, defaultOptions, options);

  return function lrChartistTooltip(chart) {
    var tooltip = document.createElement('div');
    var type;
    var x = 'x',
      y = 'y',
      points = [];
    //tooltip.style.position = 'absolute';
    tooltip.style.visibility = 'hidden';
    tooltip.style.opacity = '0';
    tooltip.style.transition = 'visibility 0s 0.5s, opacity 0.5s linear';
    chart.container.style.position = 'relative';
    chart.container.appendChild(tooltip);
    if (chart instanceof Chartist.Line) {
      type = 'point';
    }
    if (type) {
      chart.on('draw', function (data) {
        if (options.hover === 'area' && data.type === 'area') {
          document.querySelectorAll('.ct-area').forEach(function (element) {
            element.addEventListener('mousemove', function (event) {
              var { offsetX } = event;
              var seriesIndex = 0;
              var index = -1;
              points.forEach(point => {
                if (offsetX > point.x) {
                  index = point.index + 1;
                }
              });

              var point = points[index];
              var className = [options.tooltipClass, Chartist.alphaNumerate(seriesIndex)].join('-');
              point.value.y = addComma(point.value.y);
              var valObject = Chartist.extend({ meta: point.meta }, point.value);
              var matches = options.template.match(regex);
              var html = options.template;
              matches.forEach(function (m) {
                html = html.replace(m, valObject[m.substr(2, m.length - 4)], 'g');
              });
              tooltip.className = className;
              tooltip.style.left = point[x] + options.labelOffset.x + 'px';
              tooltip.style.top = point[y] + options.labelOffset.y + 'px';
              tooltip.style.display = 'inline-block';
              tooltip.style.visibility = 'visible';
              tooltip.style.opacity = '1';
              tooltip.style.transition = 'opacity 0.5s linear';
              tooltip.innerHTML = html;
            });

            element.addEventListener('mouseleave', function () {
              tooltip.style.display = 'none';
            });
          });
        }
        if (data.type === type && data.value) {
          if (data.type === 'point') {
            if (!fullPoints[data.series.chartType]) {
              fullPoints[data.series.chartType] = [];
            }
            if (!fullPoints[data.series.chartType][data.index]) {
              fullPoints[data.series.chartType][data.index] = {};
            }
            fullPoints[data.series.chartType][data.index][data.series.type] = data;
            if (points.findIndex(point => point.index === data.index) === -1) {
              points.push(data);
            }
          }
          const mouseenterListener = function () {
            var className = [options.tooltipClass, Chartist.alphaNumerate(data.seriesIndex)].join(
              '-'
            );
            let multiPoints = Object.values(fullPoints[data.series.chartType][data.index]);
            if (multiPoints.length > 1 && data.value.x >= SPLIT_DATE) {
              let pointA = multiPoints[0];
              let pointB = multiPoints[1];
              let sum = ((pointA.value.y || 0) + (pointB.value.y || 0)).toString();
              sum = addComma(sum);
              var valObject = Chartist.extend(
                { meta: data.meta },
                { ya: addComma(pointA.value.y || 0) },
                { yb: addComma(pointB.value.y || 0) },
                { sum },
                {
                  typea: pointA.series.type
                },
                { typeb: pointB.series.type }
              );
            } else {
              data.value.y = addComma(data.value.y);
              var valObject = Chartist.extend({ meta: data.meta }, data.value, {
                type: data.series.type
              });
            }

            //var valObject = Chartist.extend({ meta: data.meta }, data.value);
            var matches = options.getTemplate(data.value.x).match(regex);
            var html = options.getTemplate(data.value.x);
            matches.forEach(function (m) {
              html = html.replace(m, valObject[m.substr(2, m.length - 4)], 'g');
            });
            tooltip.className = className;
            tooltip.style.left = data[x] + options.labelOffset.x + 'px';
            if (
              data.value.x < SPLIT_DATE &&
              (data.series.chartType == 'likes' || data.series.chartType == 'comments')
            ) {
              tooltip.style.top = data[y] + options.labelOffset.y + 42 + 'px';
            } else {
              tooltip.style.top = data[y] + options.labelOffset.y + 'px';
            }
            tooltip.style.display = 'inline-block';
            tooltip.style.visibility = 'visible';
            tooltip.style.opacity = '1';
            tooltip.style.transition = 'opacity 0.5s linear';
            tooltip.style.animation = 'fadein 0.5s';
            tooltip.innerHTML = html;
            if (data.element._node.childElementCount === 1) {
              var circle = new Chartist.Svg(
                'circle',
                {
                  cx: [data.x],
                  cy: [data.y],
                  r: [5]
                },
                'hover-point'
              );

              data.element = data.element.append(circle);
            }
          };
          const mousleaveListener = function () {
            tooltip.style.visibility = 'hidden';
            tooltip.style.opacity = '0';
            tooltip.style.transition = 'visibility 0s 0.5s, opacity 0.5s linear';
            data.element._node.childNodes[1].remove();
          };
          var circle = new Chartist.Svg(
            'circle',
            {
              cx: [data.x],
              cy: [data.y],
              r: [5],
              'ct:value': data.value.y,
              'ct:meta': data.meta
            },
            'chart-point'
          );

          var group = new Chartist.Svg('g', {}, 'grop-points');
          group = group.append(circle);
          data.element = data.element.replace(group);
          data.element._node.addEventListener('mouseenter', mouseenterListener);
          data.element._node.addEventListener('mouseleave', mousleaveListener);
        }
      });
    }
  };
}

export default lrChartistTooltipFactory;
